<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ assignment ? 'Update Assignment' : 'Add Assignment' }}
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Name*">
          <d-input v-model="assignmentForm.name" :required="true" type="textarea" />
        </d-field>
        <d-field label="Description*">
          <d-input v-model="assignmentForm.description" :required="true" type="textarea" />
        </d-field>
        <d-field label="Due Date">
          <d-datepicker v-model="dueDate" :date-parser="dueDate" icon="calendar" />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          {{ assignment ? 'Update Assignment' : 'Add Assignment' }}
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import axios from 'axios';
  export default {

    data: () => ({
      saving: false,
      dueDate: '',
      assignmentForm: [{
        name: '',
        description: '',
        dueDate: '',
      }],
    }),

    methods: {
      toast(m) {
        this.$toast.open({
          message: m,
          position: 'top',
        });
      },

      async saveForm() {
        this.saving = true;
        this.assignmentForm.dueDate = this.dueDate;
        try {
          if (this.assignment) {
            await axios.patch(`/api/assignments/${this.assignmentForm.id}`, this.assignmentForm);
          } else {
            await axios.post('/api/assignments/', this.assignmentForm);
          }
          await this.$parent.events.getAssignmentsPaged();
          this.$parent.close();
        } catch (error) {
          this.processErrors(error, this.assignmentForm);
          this.$toast.open({ message: this.alertMessage[0], color: 'red-500', duration: 4000 });
        } finally {
          this.saving = false;
        }
      },

      removeUser(userIndex) {
        this.assignmentForm.assignmentUsers.splice(userIndex, 1);
      },
      resetSelectedUser() {
        this.selectedUser = '';
      },
      setSelectedUser(user) {
        this.selectedUser = user;

        if (this.selectedUser === null || this.assignmentForm.assignmentUsers.some((u) => u.userId === user.id)) {
          this.$toast.open(`${user.firstName} already selected`);
          return;
        }
        this.assignmentForm.assignmentUsers.push({ userId: this.selectedUser.id, assignmentId: this.assignment ? this.assignmentid : 0, fullName: this.selectedUser.fullName });
      },
      removeGroup(groupIndex) {
        this.assignmentForm.assignmentGroups.splice(groupIndex, 1);
      },
      resetSelectedGroup() {
        this.selectedGroup = '';
      },
      setSelectedGroup(group) {
        this.selectedGroup = group;
        if (this.selectedGroup === null || this.assignmentForm.assignmentGroups.some((g) => g.groupId === group.id)) {
          this.$toast.open(`${group.name} already selected`);
          return;
        }
        this.assignmentForm.assignmentGroups.push({ groupId: this.selectedGroup.id, assignmentId: this.assignment ? this.assignmentid : 0, groupName: this.selectedGroup.name });
      },
    },
  };
</script>